import React from 'react'

type Props = {
 label: string
 value?: string | null
 onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
 placeholder?: string
 required?: boolean
 disabled?: boolean
 className?: string
}

const CustomInputField = ({
 label,
 value,
 onChange,
 placeholder,
 required,
 disabled,
 className = '',
}: Props) => {
 return (
  <div className={`relative ${className}`}>
   <div
    className={
     `rounded-xl border px-4 py-3 focus-within:border-black ` +
     (value || disabled ? 'bg-[#F9FAFB]' : 'bg-white')
    }
   >
    <p className='text-xs text-[#3F76FF] font-medium'>
     {label}
     {required && <span className='text-red-500'>*</span>}
    </p>

    <input
     value={value || ''}
     onChange={onChange}
     disabled={disabled}
     placeholder={placeholder}
     className='mt-1 w-full bg-transparent text-lg text-gray-900 outline-none placeholder:text-gray-400'
    />
   </div>
  </div>
 )
}

export default CustomInputField
